import { render } from "./BuildingIcon.vue?vue&type=template&id=72dca0ac"
import script from "./BuildingIcon.vue?vue&type=script&lang=js"
export * from "./BuildingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__